// Lucide icon: truck (https://lucide.dev/icons/truck)
import { Truck } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconReceive = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Truck />
    </IconComponentStyled>
  )
}
